<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    document.getElementsByTagName('title')[0].textContent = this.option.name
  }
}
</script>

<style>
  body{
    font-family: "微软雅黑", "宋体";
  }
</style>



// WEBPACK FOOTER //
// src/App.vue